var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_287_182760)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.0254,
    cy: 30,
    r: 22,
    fill: "#00E88F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2505 30.892C29.5659 31.2252 29.5659 31.7654 29.2505 32.0986L22.789 38.9242C22.4735 39.2574 21.9621 39.2574 21.6467 38.9242C21.3313 38.591 21.3313 38.0508 21.6467 37.7176L28.1083 30.892C28.4237 30.5588 28.9351 30.5588 29.2505 30.892Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8364 30.3577C29.3197 30.3577 29.7114 30.7715 29.7114 31.282V36.2116C29.7114 36.7221 29.3197 37.1359 28.8364 37.1359C28.3532 37.1359 27.9614 36.7221 27.9614 36.2116V32.2063H24.1698C23.6865 32.2063 23.2948 31.7925 23.2948 31.282C23.2948 30.7715 23.6865 30.3577 24.1698 30.3577C24.1698 30.3577 28.3532 30.3577 28.8364 30.3577Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2505 30.892C29.5659 31.2252 29.5659 31.7654 29.2505 32.0986L22.789 38.9242C22.4735 39.2574 21.9621 39.2574 21.6467 38.9242C21.3313 38.591 21.3313 38.0508 21.6467 37.7176L28.1083 30.892C28.4237 30.5588 28.9351 30.5588 29.2505 30.892Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8364 30.3577C29.3197 30.3577 29.7114 30.7715 29.7114 31.282V36.2116C29.7114 36.7221 29.3197 37.1359 28.8364 37.1359C28.3532 37.1359 27.9614 36.7221 27.9614 36.2116V32.2063H24.1698C23.6865 32.2063 23.2948 31.7925 23.2948 31.282C23.2948 30.7715 23.6865 30.3577 24.1698 30.3577C24.1698 30.3577 28.3532 30.3577 28.8364 30.3577Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7556 28.9701C30.4402 28.6369 30.4402 28.0967 30.7556 27.7635L37.2171 20.9378C37.5326 20.6046 38.044 20.6046 38.3594 20.9378C38.6748 21.271 38.6748 21.8113 38.3594 22.1445L31.8978 28.9701C31.5824 29.3033 31.071 29.3033 30.7556 28.9701Z",
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1697 29.5044C30.6864 29.5044 30.2947 29.0906 30.2947 28.5801L30.2947 23.6505C30.2947 23.14 30.6864 22.7262 31.1697 22.7262C31.6529 22.7262 32.0447 23.14 32.0447 23.6505L32.0447 27.6558L35.8363 27.6558C36.3196 27.6558 36.7113 28.0696 36.7113 28.5801C36.7113 29.0906 36.3196 29.5044 35.8363 29.5044C35.8363 29.5044 31.6529 29.5044 31.1697 29.5044Z",
    fill: "#111111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7556 28.9701C30.4402 28.6369 30.4402 28.0967 30.7556 27.7635L37.2171 20.9378C37.5326 20.6046 38.044 20.6046 38.3594 20.9378C38.6748 21.271 38.6748 21.8113 38.3594 22.1445L31.8978 28.9701C31.5824 29.3033 31.071 29.3033 30.7556 28.9701Z",
    fill: "#111111"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1697 29.5044C30.6864 29.5044 30.2947 29.0906 30.2947 28.5801L30.2947 23.6505C30.2947 23.14 30.6864 22.7262 31.1697 22.7262C31.6529 22.7262 32.0447 23.14 32.0447 23.6505L32.0447 27.6558L35.8363 27.6558C36.3196 27.6558 36.7113 28.0696 36.7113 28.5801C36.7113 29.0906 36.3196 29.5044 35.8363 29.5044C35.8363 29.5044 31.6529 29.5044 31.1697 29.5044Z",
    fill: "#111111"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_287_182760",
    x: 0.0253906,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_287_182760"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_287_182760",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/Collapse.7e641f7260f77fc2a9e61c31668eb567.svg";
export { ForwardRef as ReactComponent };